import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[85vh] min-h-[600px] max-h-[900px] overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 mx-5 md:mx-7 my-4 md:my-5 rounded-[24px] md:rounded-[32px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20amber%20and%20deep%20coral%20gradients%2C%20overlapping%20translucent%20circles%20and%20soft%20organic%20shapes%2C%20dark%20dramatic%20atmosphere%20with%20golden%20light%20bursts%2C%20luxurious%20velvet%20texture%2C%20editorial%20design%20aesthetic%2C%20high%20contrast%2C%20mysterious%20and%20elegant%20vibe%2C%20magazine%20cover%20quality&width=1800&height=1000&seq=hero-main-bg&orientation=landscape"
          alt="黑料网 - 娱乐八卦资讯平台"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-6 md:px-10">
        {/* Pill badge */}
        <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm mb-6">
          <i className="ri-fire-line text-sm text-primary-400 mr-2"></i>
          <span className="text-xs md:text-sm text-white/90 font-medium tracking-wide">
            今日热搜 · 实时更新
          </span>
        </div>

        {/* Main heading */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white text-center leading-tight mb-5 max-w-3xl">
          娱乐圈的真相
          <br />
          从这里开始
        </h1>

        {/* Subtitle */}
        <p className="text-sm md:text-base text-white/70 text-center max-w-xl leading-relaxed mb-8">
          每日更新最新明星黑料、网红爆料、娱乐圈内幕，
          <br className="hidden md:block" />
          千万吃瓜群众的首选资讯平台
        </p>

        {/* CTA buttons */}
        <div className="flex items-center gap-4">
          <Link
            to="/category/star-gossip"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 border border-white/30 hover:border-white/60 text-white text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-xs text-white/50">向下滚动</span>
          <i className="ri-arrow-down-s-line text-white/50"></i>
        </div>
      </div>
    </section>
  );
}